import type { FormLabelMap } from '../../formLabels'

// The stored labels are already English: nothing to map (ADR-111 D2).
export const FORM_LABEL_EN: FormLabelMap = {}
